import { render, staticRenderFns } from "./ReportMailProvider.vue?vue&type=template&id=1327699c&scoped=true"
import script from "./ReportMailProvider.vue?vue&type=script&lang=js"
export * from "./ReportMailProvider.vue?vue&type=script&lang=js"
import style0 from "./ReportMailProvider.vue?vue&type=style&index=0&id=1327699c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327699c",
  null
  
)

export default component.exports